var React = require('react');

function FeatureGladed (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(-960.000000, -8157.000000)"},React.createElement("g",{"transform":"translate(69.000000, 7650.000000)"},React.createElement("path",{"d":"M900.6,516.28 C900.6,518.816 898.8696,520.116 896.6,520.5232 L896.6,523 L895,523 L895,520.5232 C892.7304,520.116 891,518.816 891,516.28 C891,512.3088 894.6,507 895.8,507 C897,507 900.6,512.1504 900.6,516.28"})))));
}

FeatureGladed.defaultProps = {"role":"presentation","viewBox":"0 0 10 16","version":"1.1"};

module.exports = FeatureGladed;

FeatureGladed.default = FeatureGladed;
